import { Helmet } from "react-helmet";
import { SideBar } from "../side-bar/SideBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import SetTimeButton from "../buttons/attendance-buttons/SetTimeButton";
import * as endPoint from "../../../config/config";
import { api, getToken } from "../../../services/apis/auth-api/apiUrl";
import { useAuth } from "../../../services/auth-services/authContext";
import { AuthContextState } from "../../../utils/types";
import { months } from "../../../utils/time.date.utlis";

interface attendanceDataTodayProps {
    work_setup : string;
    sigin_in : string;
    break_stat : string;
    sign_out : string;
    working_hour : string;
    remaining_break : number;
    break_consumed : number;
    tardiness : number;
    over_break : number;
    under_time : string;
}

interface attendanceRecordProps {
    work_setup : string;
    date : string;
    sign_in : string;
    break_consumed : number;
    sign_out : string;
    working_hours : string;
    tardiness : number;
    under_time : string;
    over_break : number;
}

export default function UserAttendance () {

    const curr_date : Date = new Date();
    const currentYear = curr_date.getFullYear();
    const currentMonth = curr_date.getMonth();

    const [date, setDate] = useState<string>('');
    const [time, setTime] = useState<string>('');

    const {decodedJwtData} = useAuth() as AuthContextState;
    const account_id = decodedJwtData?.userId;
    const [attendanceDataToday, setAttendanceDataToday] = useState<attendanceDataTodayProps | null>(null);
    const [submitted, setSubmitted] = useState<any>();

    const [monthlyRecord, setMonthlyRecord] = useState<attendanceRecordProps[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [year, setYear] = useState<number>(currentYear);
    const [month, setMonth] = useState<number>(currentMonth);
    const [search, setSearch] = useState<string>('');

    const monthlyAttendance = monthlyRecord.filter((record)=>
        record.date.toLowerCase().includes(search.toLowerCase())
    )

    useEffect(()=>{
        const handleAttendanceTodayProcess = async() => {
            try{
                const attendance_today = await api.get(
                    endPoint.GET_ATTENDANCE_DATA_TODAY_END_POINT+account_id,{
                        headers : {'Authorization' : 'Bearer '+getToken()}
                    }
                )
                setAttendanceDataToday(attendance_today.data);
            }catch(e){}
        }
        handleAttendanceTodayProcess();
    }, [account_id, submitted])

    useEffect(()=>{
        const handleAttendanceRecord = async() => {
            try{
                const attendance_records = await api.get(
                    endPoint.GET_MONTHLY_ATTENDANCE_RECORD_END_POINT+`${year}/${month + 1}/${account_id}`,{
                        headers : {'Authorization' : 'Bearer '+getToken()}
                    }
                )
                setMonthlyRecord(attendance_records.data);
                setIsLoading(false);
            }catch(e){
                setIsLoading(false);
            }
        }
        handleAttendanceRecord();
    },[account_id, month, year])

    useEffect(()=>{
        const options : Intl.DateTimeFormatOptions = { 
            weekday : 'long',
            year: 'numeric', 
            month: 'long', 
            day: 'numeric'
        };
        const formattedDate = curr_date.toLocaleDateString('en-US', options);
        setDate(formattedDate)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    function handleTime () {
        const now: Date = new Date();
        let hours: number = now.getHours();
        const minutes: string = now.getMinutes().toString().padStart(2, '0');
        const seconds: string = now.getSeconds().toString().padStart(2, '0');
        const ampm: string = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12;
        const curr_time: string = `${hours.toString().padStart(2, '0')}:${minutes}:${seconds} ${ampm}`;

        setTime(curr_time);
    }

    setInterval(handleTime, 1000);

    function incrementMonth(){
        let index = month;
        index++;
        setMonth(index < 12 ? index : 0);
        setIsLoading(true);
    }

    function decrementMonth(){
        let index = month;
        index--;
        setMonth(index === -1 ? 11 : index);
        setIsLoading(true);
    }
    
    const incrementYear = () => {
        setYear(year + 1);
        setIsLoading(true);
    }

    const decrementYear = () => {
        setYear(year - 1);
        setIsLoading(true);
    }
    
    return (
        <div className="content flex">
            <Helmet>
                <title>Attendance</title>
            </Helmet>

            <SideBar />
            
            <div className='main-content'>
                <div className="w-full flex flex-col gap-4 bg-white p-4 text-gray-600">
                    <div className="w-full flex">
                        <div>
                            <h1 className="text-xl uppercase">Attendance</h1>
                        </div>
                        <div className="ms-auto text-xl font-semibold">
                            {date}, {time}
                        </div>
                    </div>
                    <div className="flex w-full">
                        <div>
                           
                        </div>
                        <SetTimeButton onSubmit={(res)=>setSubmitted(res)} hasAttendanceToday={attendanceDataToday?.sigin_in !== '00:00' ? true : false} />
                    </div>
                </div>
                <div className="bg-white w-full p-4">
                    <div className="my-2">
                        Attendance Log Today
                    </div>
                    <div className="tbl-container">
                        <table className="w-full">
                            <thead className="table-headers">
                                <tr>
                                    <th className="font-normal text-center">Sign in</th>
                                    <th className="font-normal text-center">Sign in</th>
                                    <th className="font-normal text-center">Break status</th>
                                    <th className="font-normal text-center">Sign out</th>
                                    <th className="font-normal text-center">Working hours</th>
                                    <th className="font-normal text-center">Remaining Break Time</th>
                                    <th className="font-normal text-center">Break Consumed</th>
                                    <th className="font-normal text-center">Tardiness</th>
                                    <th className="font-normal text-center">Over Break</th>
                                    <th className="font-normal text-center">Under Time</th>
                                </tr>
                            </thead>
                            <tbody className="table-body">
                                {attendanceDataToday ? (
                                    <>
                                       <tr>
                                            <td className="text-center py-1 px-3">
                                                <span className="bg-yellow-300 shadow-xl rounded-lg text-sm px-2 py-0.5">
                                                    {attendanceDataToday.work_setup}
                                                </span>
                                            </td>
                                            <td className="text-center py-1 px-3">
                                                <span className="bg-green-300 shadow-xl rounded-lg text-sm px-2 py-0.5">
                                                    {attendanceDataToday.sigin_in}
                                                </span>
                                            </td>
                                            <td className="text-center py-1 px-3">
                                                <span className="bg-gray-300 shadow-xl rounded-lg text-sm px-2 py-0.5">
                                                    {attendanceDataToday.break_stat}
                                                </span>
                                            </td>
                                            <td className="text-center py-1 px-3">
                                                <span className="bg-red-200 shadow-xl rounded-lg text-sm px-2 py-0.5">
                                                    {attendanceDataToday.sign_out}
                                                </span>
                                            </td>
                                            <td className="text-center py-1 px-3">
                                                <span className="bg-gray-300 shadow-xl rounded-lg text-sm px-2 py-0.5">
                                                    {attendanceDataToday.working_hour}
                                                </span>
                                            </td>
                                            <td className="text-center py-1 px-3">
                                                <span className="bg-gray-300 shadow-xl rounded-lg text-sm px-2 py-0.5">
                                                    {attendanceDataToday.remaining_break} mins.
                                                </span>
                                            </td>
                                            <td className="text-center py-1 px-3">
                                                <span className="bg-gray-300 shadow-xl rounded-lg text-sm px-2 py-0.5">
                                                    {attendanceDataToday.break_consumed} mins.
                                                </span>
                                            </td>
                                            <td className="text-center py-1 px-3">
                                                <span className="bg-red-300 shadow-xl rounded-lg text-sm px-2 py-0.5">
                                                    {attendanceDataToday.tardiness} mins.
                                                </span>
                                            </td>
                                            <td className="text-center py-1 px-3">
                                                <span className="bg-red-300 shadow-xl rounded-lg text-sm px-2 py-0.5">
                                                    {attendanceDataToday.over_break} mins.
                                                </span>
                                            </td>
                                            <td className="text-center py-1 px-3">
                                                <span className="bg-red-300 shadow-xl rounded-lg text-sm px-2 py-0.5">
                                                    {attendanceDataToday.under_time}
                                                </span>
                                            </td>
                                        </tr>
                                    </>
                                ) : (
                                    <>
                                        <td className="text-center py-1" colSpan={8}>You have no attendance today.</td>
                                    </>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="bg-white w-full p-4 my-4">
                    <div className="my-2">
                        Attendance Log
                    </div>
                    <div className="flex gap-4 my-2">
                        <div className="flex gap-4 text-xl text-gray-700">
                        <div>
                            <button onClick={decrementYear} className="hover:text-orange-500" >
                                <FontAwesomeIcon icon={faAngleLeft} />
                            </button>
                        </div>
                        <div>
                            {year}
                        </div>
                        <div>
                            <button onClick={incrementYear} className="hover:text-orange-500" >
                                <FontAwesomeIcon icon={faAngleRight} />
                            </button>
                        </div>
                        </div>

                        <div className="flex gap-4 w-40 text-xl text-gray-700">
                            <div>
                                <button onClick={decrementMonth} className="hover:text-orange-500">
                                    <FontAwesomeIcon icon={faAngleLeft} />
                                </button>
                            </div>
                            <div className="w-24 text-center">
                                {months[month]}
                            </div>
                            <div className="ms-auto">
                                <button onClick={incrementMonth} className="hover:text-orange-500">
                                    <FontAwesomeIcon icon={faAngleRight} />
                                </button>
                            </div>
                        </div>
                        <div className="ms-auto">
                            <input type="text" onChange={(e)=>setSearch(e.target.value)} value={search} className="text-box" placeholder="Search date...." />
                        </div>
                    </div>
                    <div className="tbl-container h-[21rem] overflow-y-auto overflow-x-auto hide-scrollbar">
                        <table className="w-full">
                            <thead className="table-headers table-fixed-header">
                                <tr>
                                    <th className="table-headers text-center">Work Setup</th>
                                    <th className="table-headers text-center">Date</th>
                                    <th className="table-headers text-center">Sign in</th>
                                    <th className="table-headers text-center">Break Consumed</th>
                                    <th className="table-headers text-center">Sign out</th>
                                    <th className="table-headers text-center">Working hours</th>
                                    <th className="table-headers text-center">Tardiness</th>
                                    <th className="table-headers text-center">Under Time</th>
                                    <th className="table-headers text-center">Over Break</th>
                                </tr>
                            </thead>
                            <tbody className="table-body">
                                {isLoading ? (
                                    <>
                                        <tr className="">
                                            <td className='table-body'>
                                                <div className="table-loading"></div>
                                            </td>
                                            <td className='table-body'>
                                                <div className="table-loading"></div>
                                            </td>
                                            <td className='table-body'>
                                                <div className="table-loading"></div>
                                            </td>
                                            <td className='table-body'>
                                                <div className="table-loading"></div>
                                            </td>
                                            <td className='table-body'>
                                                <div className="table-loading"></div>
                                            </td>
                                            <td className='table-body'>
                                                <div className="table-loading"></div>
                                            </td>
                                            <td className='table-body'>
                                                <div className="table-loading"></div>
                                            </td>
                                             <td className='table-body'>
                                                <div className="table-loading"></div>
                                            </td>
                                             <td className='table-body'>
                                                <div className="table-loading"></div>
                                            </td>
                                        </tr>
                                        <tr className="">
                                            <td className='table-body'>
                                                <div className="table-loading"></div>
                                            </td>
                                            <td className='table-body'>
                                                <div className="table-loading"></div>
                                            </td>
                                            <td className='table-body'>
                                                <div className="table-loading"></div>
                                            </td>
                                            <td className='table-body'>
                                                <div className="table-loading"></div>
                                            </td>
                                            <td className='table-body'>
                                                <div className="table-loading"></div>
                                            </td>
                                            <td className='table-body'>
                                                <div className="table-loading"></div>
                                            </td>
                                            <td className='table-body'>
                                                <div className="table-loading"></div>
                                            </td>
                                             <td className='table-body'>
                                                <div className="table-loading"></div>
                                            </td>
                                             <td className='table-body'>
                                                <div className="table-loading"></div>
                                            </td>
                                        </tr>
                                    </>
                                ) : (<>
                                    {monthlyRecord.length > 0 ? (
                                        <>
                                            {monthlyAttendance.map((record) => (
                                                <>
                                                    <tr className="hover:bg-gray-300">
                                                        <td className="table-body text-center py-1 uppercase">{record.work_setup}</td>
                                                        <td className="table-body text-center py-1">{record.date}</td>
                                                        <td className="table-body text-center py-1">{record.sign_in}</td>
                                                        <td className="table-body text-center py-1">{record.break_consumed} minute/s</td>
                                                        <td className="table-body text-center py-1">{record.sign_out}</td>
                                                        <td className="table-body text-center py-1">{record.working_hours}</td>
                                                        <td className="table-body text-center py-1">{record.tardiness}</td>
                                                        <td className="table-body text-center py-1">{record.under_time}</td>
                                                        <td className="table-body text-center py-1">{record.over_break} minute/s</td>
                                                    </tr>
                                                </>
                                            ))}
                                        </>
                                    ) : (
                                        <>
                                            <tr>
                                                <td className="table-body text-center py-1" colSpan={7}>No record found.</td>
                                            </tr>
                                        </>
                                    )}
                                </>)}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </div>
    );
}